import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=0abf66e4"
import script from "./selector.ts?vue&type=script&lang=js&external"
export * from "./selector.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports